import { FacetBase } from "../../models/facet-base/facet-base";

export const getFacetFromUrlParam = (
	paramName: string,
	facets: any,
): FacetBase => {
	for (let index = 0; index < Object.keys(facets).length; index++) {
		const facet = facets[index] as any;

		if (facet.urlParamName.toLowerCase() === paramName.toLowerCase()) {
			return facet;
		}
	}

	return null;
};
